import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Navbar from '../../../src/navbar';
import { productsService } from '../../services/api/products.service';

function CategoryDelete() {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await productsService.getCategoryById(id);
        setCategory(data);
      } catch (err) {
        setError((err && (err.message || err.error)) || String(err));
      }
    };

    fetch();
  }, [id]);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      await productsService.deleteCategory(id);
      navigate('/categories');
    } catch (err) {
      setError((err && (err.message || err.error)) || String(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex">
        <Navbar />
      </div>
      <div className="max-w-3xl mx-auto p-4 mt-20">
        <h1 className="text-2xl font-bold mb-4">Delete Category</h1>
        {error && <div className="text-red-600 mb-4">{error}</div>}
        {!category ? (
          <div>Loading...</div>
        ) : (
          <div>
            <p className="mb-4">Are you sure you want to delete <strong>{category.name}</strong>?</p>
            <div className="space-x-3">
              <button onClick={handleDelete} disabled={loading} className="bg-red-600 text-white px-4 py-2 rounded">{loading ? 'Deleting...' : 'Delete'}</button>
              <Link to="/categories" className="px-4 py-2 rounded border">Cancel</Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CategoryDelete;
